import { zodResolver } from "@hookform/resolvers/zod";
import { stringToDate } from "helpers/date";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { TransportSedel } from "types/transportSedel.type";
import { z } from "zod";
import { usePatchTransportSedelSheet } from "./usePatchTransportSedelSheet";

const departureSchema = z.object({
  timeOfDepartureUtc: z.coerce.date({
    required_error: "Obligatoriskt fält",
    message: "Obligatoriskt fält",
  }),
});
type TDepartureSchema = z.infer<typeof departureSchema>;

export const useUpdateDepartureLogic = (transportSedel: TransportSedel) => {
  const sheet = usePatchTransportSedelSheet();

  const form = useForm<TDepartureSchema>({
    resolver: zodResolver(departureSchema),
    defaultValues: {
      timeOfDepartureUtc: stringToDate(transportSedel.timeOfDepartureUtc),
    },
  });

  useEffect(() => {
    if (sheet.isModalOpen) {
      form.reset({
        timeOfDepartureUtc: stringToDate(transportSedel.timeOfDepartureUtc),
      });
    }
  }, [form, transportSedel, sheet.isModalOpen]);

  const onSubmit = form.handleSubmit((data: TDepartureSchema) => {
    sheet.mutation.mutate({
      id: transportSedel.id,
      payload: { timeOfDepartureUtc: data.timeOfDepartureUtc },
    });
  });

  return {
    isModalOpen: sheet.isModalOpen,
    openModal: sheet.openModal,
    onModalClose: sheet.onModalClose,
    form,
    onSubmit,
    isPending: sheet.mutation.isPending,
  };
};

export type UpdateDepartureLogicRetVal = ReturnType<
  typeof useUpdateDepartureLogic
>;
